export const prodApiLSKey = `marpla_qa_isProdApi`;
export const visibilityLSKey = `marpla_qa_isCollapsed`;
